import * as React from 'react'
import { IStageProps } from 'app/types'
import { formatTime } from 'app/service/util'


export default class FinishStage extends React.Component<IStageProps, {}> {

  onJoinInterestList = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSdw3aJ3JWndUI0hNKJLNhWz9GcipiM18a1UjcWa8Pe2tTO4dQ/viewform?usp=sf_link', '_blank')
  }

  render() {
    const { time } = this.props

    return (

      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100vw', height: '100vh', flexDirection: 'column'}}>
        <h1 style={{fontSize: '22vw', margin: 0, color: '#eee', lineHeight: 1}}>FREEDOM</h1>

        <p style={{textAlign: 'center', fontSize: '5vw', color: '#666', padding: 0, margin: 0}}>You escaped in {formatTime(time)}</p>

        <p style={{textAlign: 'center', fontSize: 20, color: '#666', padding: 0, marginTop: '1em'}}>This was a demo. Join the interest list to get the full version for free.</p>

        <div>
          <button style={{marginTop: '1em', backgroundColor: '#999', color: 'white', fontSize: '3vw', marginRight: '1em', paddingLeft: '1em', paddingRight: '1em', paddingTop: '0.25em', paddingBottom: '0.25em'}} onClick={this.props.onNext}>Home</button>
          <button style={{marginTop: '1em', backgroundColor: '#666', color: 'white', fontSize: '3vw', paddingLeft: '1em', paddingRight: '1em', paddingTop: '0.25em', paddingBottom: '0.25em'}} onClick={this.onJoinInterestList}>Join interest list</button>
        </div>


      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/stage/finish.tsx